(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/prolongation/views/prolongation.js') >= 0) return;  svs.modules.push('/modules/lotto/components/prolongation/views/prolongation.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lotto=_svs.lotto||{};
_svs.lotto.components=_svs.lotto.components||{};
_svs.lotto.components.prolongation=_svs.lotto.components.prolongation||{};
_svs.lotto.components.prolongation.templates=_svs.lotto.components.prolongation.templates||{};
svs.lotto.components.prolongation.templates.prolongation = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"prolongationContentRegion\"></div>\n";
},"useData":true});
Handlebars.partials['svs-lotto-components-prolongation-prolongation'] = svs.lotto.components.prolongation.templates.prolongation;
})(svs, Handlebars);

 })(window);